import format from 'format-number'
import { DEFAULT_CURRENCY_SYMBOL } from '../helpers/currency'

export default function(value, symbol = DEFAULT_CURRENCY_SYMBOL) {
  const parsed = parseFloat(value) || 0

  return format({ prefix: symbol, padRight: 2 })(parsed.toFixed(2))
}
